import { SortingCriteria, VehicleListing } from '@cinch-nx/data-search'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { fetchSearchVehicles } from '@retail-common/data-search-vehicles-api'
import { SearchParams } from '@retail-common/util-search-param-types'
import { ReactNode, useEffect, useState } from 'react'
import CarouselSection from './carousel-section/carousel-section'

export interface CarsCarouselProps {
  title?: string
  sortBy?: SortingCriteria
  showOnlyCinchStock?: boolean
  priceFrom?: number
  priceTo?: number
  carsCondition?: 'new' | 'used'
  make?: string
  disclaimer?: string
  showMonthlyPrices?: boolean
  showBrowseAllCarsCard?: boolean
  financeRepresentativeExample?: ReactNode
}

export function CarsCarousel({
  title,
  sortBy,
  priceFrom,
  priceTo,
  carsCondition,
  make,
  disclaimer,
  showMonthlyPrices,
  showBrowseAllCarsCard = false,
  financeRepresentativeExample,
}: CarsCarouselProps) {
  const [vehicles, setVehicles] = useState<VehicleListing[]>()
  useEffect(() => {
    const fetchVehicleData = async (params: Partial<SearchParams>) => {
      const data = await fetchSearchVehicles(
        readFromEnv(Env.SearchServiceUrl),
        params,
      )
      setVehicles(data.response.vehicleListings)
    }

    fetchVehicleData({
      ...(priceFrom && { fromPrice: [String(priceFrom)] }),
      ...(priceTo && { toPrice: [String(priceTo)] }),
      ...(sortBy && { sortingCriteria: sortBy }),
      ...(carsCondition && { condition: [carsCondition] }),
      ...(make && { make: [make] }),
    })
  }, [])

  return (
    <CarouselSection
      title={title}
      disclaimer={disclaimer}
      vehicles={vehicles}
      showBrowseAllCarsCard={showBrowseAllCarsCard}
      showMonthlyPrices={showMonthlyPrices}
      financeRepresentativeExample={financeRepresentativeExample}
    />
  )
}

export default CarsCarousel
